<template>
  <div>
    <div class="hidden lg:block fixed top-0 left-3 bg-green-7 w-1/3 2xl:w-3/12 h-screen" />
    <div
      class="
        hidden
        lg:block
        fixed
        top-0
        left-0
        flex-grow flex-col
        lg:pt-28
        side-bar
        w-1/3
        2xl:w-3/12
      "
    >
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props:{
    overflow:{
      type: Boolean,
      default: false
    }
  }
}
</script>
